import apiendpoints from "../../../apiendpoints";
import { api } from "@/utils/requests"

export default {
    loginAttempt({ dispatch }, payload) {
    },
    updateRole ({commit}, payload) {
        // console.log("Updating Role")
        commit('UPDATE_AUTHENTICATED_ROLE', payload.role);
        if (payload.instance) {
            payload.instance.$acl.change(payload.role)
        }
    },
    updateUserToken ({ commit }, token) {
        commit('UPDATE_USER_TOKEN', token)
    },
    updateAuthenticatedUser({ commit, state, dispatch }, payload) {
        commit('UPDATE_AUTHENTICATED_USER', payload)
    },
    logout ({dispatch, commit}) {
        return new Promise((resolve) => {
            dispatch('updateRole', {role: 'public'})
            dispatch('updateAuthenticatedUser', null)
            commit('LOGOUT_USER')
            let t = api.logout({url: apiendpoints.logout})
            if (t) {
                t.then(
                    () => resolve(),
                    (err) => reject(err)
                )
            } else {
                resolve()
            }
        })
    }
}
